import {
  cta_linkTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_lg,
  font_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const container = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 420px;
  margin: 0 auto;
  padding: ${spacing(28)} ${spacing(4)};
`

export const illustration = css`
  width: 118px;
  height: auto;
  margin-bottom: ${spacing(5)};
`

export const heading = css`
  ${font_lg};
  font-family: ${font_family_weight_medium};
`

export const body = css`
  ${font_md};
  color: ${text_colorTextSecondary};
  margin-top: ${spacing(2)};
`

export const supportLink = css`
  color: ${cta_linkTextPrimary};
  text-decoration: underline;

  &:hover {
    cursor: pointer;
  }
`
